<div class="curation-wrap" [nbSpinner]="loading | async" nbSpinnerStatus="primary">
  <nb-card>
    <nb-card-header class="curation-header">
      <div class="title">
        <h5>Skill curation queue</h5>
        <span class="subtitle" *ngIf="meta.total">{{ meta.total }} pending</span>
      </div>

      <div class="bulk-bar" *ngIf="bulkCount > 0">
        <span class="bulk-count">{{ bulkCount }} selected</span>
        <button nbButton size="small" status="success" (click)="bulkApprove()">
          <nb-icon icon="checkmark-outline"></nb-icon> Approve
        </button>
        <button nbButton size="small" status="danger" ghost (click)="bulkReject()">
          <nb-icon icon="close-outline"></nb-icon> Reject
        </button>
      </div>
    </nb-card-header>

    <nb-card-body class="curation-body">
      <!-- Empty state: the tapering steady state. -->
      <div class="empty-state" *ngIf="!(loading | async) && candidates.length === 0">
        <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
        <p>Nothing to review</p>
        <span>Auto-created skills awaiting approval will appear here.</span>
      </div>

      <table class="curation-table" *ngIf="candidates.length > 0">
        <thead>
          <tr>
            <th class="col-check">
              <nb-checkbox [checked]="allSelected" (checkedChange)="toggleSelectAll()"></nb-checkbox>
            </th>
            <th class="col-name">Skill</th>
            <th class="col-match">Nearest existing match</th>
            <th class="col-sample">Sample vacancy</th>
            <th class="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of candidates">
            <tr [class.busy]="busyIds.has(row.id)">
              <td class="col-check">
                <nb-checkbox [checked]="selectedIds.has(row.id)" (checkedChange)="toggleSelect(row.id)"></nb-checkbox>
              </td>
              <td class="col-name"><strong>{{ row.name }}</strong></td>
              <td class="col-match">
                <ng-container *ngIf="row.nearest_match_name; else noMatch">
                  {{ row.nearest_match_name }}
                  <nb-badge *ngIf="scorePercent(row.nearest_match_score) as pct"
                            [text]="pct" status="info" position="top right" class="score-badge"></nb-badge>
                </ng-container>
                <ng-template #noMatch><span class="muted">—</span></ng-template>
              </td>
              <td class="col-sample">
                <span class="muted" *ngIf="!row.sample_vacancy_title">—</span>
                <span *ngIf="row.sample_vacancy_title" [nbTooltip]="row.sample_vacancy_title">
                  {{ row.sample_vacancy_title }}
                </span>
              </td>
              <td class="col-actions">
                <button nbButton size="tiny" status="success" [disabled]="busyIds.has(row.id)"
                        (click)="approve(row)" nbTooltip="Approve as a live skill">
                  <nb-icon icon="checkmark-outline"></nb-icon>
                </button>
                <button nbButton size="tiny" status="basic" [disabled]="busyIds.has(row.id)"
                        (click)="openMerge(row)" nbTooltip="Merge into an existing skill">
                  <nb-icon icon="flip-2-outline"></nb-icon>
                </button>
                <button nbButton size="tiny" status="warning" ghost [disabled]="busyIds.has(row.id)"
                        (click)="reclassify(row)" nbTooltip="Move to Development (soft skill)">
                  <nb-icon icon="swap-outline"></nb-icon>
                </button>
                <button nbButton size="tiny" status="danger" ghost [disabled]="busyIds.has(row.id)"
                        (click)="reject(row)" nbTooltip="Reject (archive)">
                  <nb-icon icon="trash-2-outline"></nb-icon>
                </button>
              </td>
            </tr>

            <!-- Inline merge typeahead -->
            <tr class="merge-row" [class.busy]="busyIds.has(row.id)" *ngIf="mergeRowId === row.id">
              <td colspan="5">
                <div class="merge-panel">
                  <div class="merge-input">
                    <input nbInput fullWidth fieldSize="small" [value]="mergeQuery"
                           (input)="onMergeQueryChange($any($event.target).value)"
                           [nbSpinner]="mergeSearching" placeholder="Search skill to merge into…" />
                    <button nbButton size="tiny" ghost status="basic" (click)="closeMerge()">
                      <nb-icon icon="close-outline"></nb-icon>
                    </button>
                  </div>
                  <nb-list class="merge-results" *ngIf="mergeResults.length > 0">
                    <nb-list-item *ngFor="let s of mergeResults" class="merge-result"
                                  (click)="confirmMerge(row, s)">
                      <nb-icon icon="corner-down-right-outline"></nb-icon> {{ s.name }}
                    </nb-list-item>
                  </nb-list>
                  <div class="merge-empty muted"
                       *ngIf="!mergeSearching && mergeQuery.trim().length >= 2 && mergeResults.length === 0">
                    No matching skills.
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="curation-pager" *ngIf="meta.last_page > 1">
        <button nbButton size="small" ghost [disabled]="meta.current_page <= 1"
                (click)="load(meta.current_page - 1)">
          <nb-icon icon="chevron-left-outline"></nb-icon>
        </button>
        <span class="page-label">{{ meta.current_page }} / {{ meta.last_page }}</span>
        <button nbButton size="small" ghost [disabled]="meta.current_page >= meta.last_page"
                (click)="load(meta.current_page + 1)">
          <nb-icon icon="chevron-right-outline"></nb-icon>
        </button>
      </div>
    </nb-card-body>
  </nb-card>
</div>
